<div
  class="classroom-card"
  [ngClass]="{ 'no-navigation': !canNavigate }"
  [routerLink]="canNavigate ? route : null"
>
  <div class="name-container">
    <div class="name">{{ classListItem.className }}</div>
  </div>
  <div class="grade">Grade: {{ classListItem.gradeLevel }}</div>
</div>
